import { ToastContainer as Toaster } from 'react-toastify';

import styled from 'styled-components';

import { NavBarwidth } from 'const';
import { pxToRem } from 'utils/scss';

export const IconWrapper = styled.div`
  margin: ${props =>
    props.isClose
      ? `${pxToRem('24px')} ${pxToRem('28px')}`
      : `0 ${pxToRem('28px')}`};
`;

export const ToastWrapper = styled.div`
  padding: 0;
  .Toastify__toast-container {
    top: ${pxToRem('104px')};
    left: calc(50vw + ${pxToRem(NavBarwidth)});
    width: ${pxToRem('628px')};
  }

  .Toastify__toast {
    padding: 0;
  }
`;

export const ToastContainer = styled(Toaster)`
  .Toastify__toast--default,
  .Toastify__toast--success,
  .Toastify__toast--error {
    background-color: white;
    box-shadow: 0 ${pxToRem('24px')} ${pxToRem('32px')} -${pxToRem('16px')} rgba(0, 0, 0, 0.11);
    color: black;
    border-radius: ${pxToRem('16px')};
  }

  .Toastify__toast--success {
    border: ${pxToRem('2px')} solid ${props => props.theme.colors.statusGreen};
    background-color: rgba(221, 250, 243);
    color: black;
  }

  .Toastify__toast--error {
    border: ${pxToRem('2px')} solid ${props => props.theme.colors.statusRed};
    background-color: rgba(254, 233, 233);
    color: black;
  }
`;

export const ToastCustomContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;

  > div {
    margin-left: ${pxToRem('10px')};
  }
`;
